export default __webpack_public_path__ + "static/media/weave.15df6ff2.svg";